import events from 'events';

export default Object.create(events.prototype);



// WEBPACK FOOTER //
// ./src/component/view/events.js